<template>
  <div>
    <header>
      <div class="fullSize">
        <div class="topLogo fullCenter">
          <div class="webLogo"></div>
          <div class="topSearch">
            <input
              type="text"
              class="topSearch_ipt"
              placeholder="搜索本站内容"
              v-model="searchValue"
            />
            <button class="topSearch_btn" @click="showSearch"></button>
          </div>
        </div>
      </div>
      <div class="fullSize menuBkg">
        <div class="fullCenter">
          <div class="le-menu">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-menu-item index="/">首页</el-menu-item>
              <el-submenu index="2">
                <template slot="title">关于分会</template>
                <el-menu-item index="synopsis">分会简介</el-menu-item>
                <el-menu-item index="orgChart">组织架构</el-menu-item>
                
                <el-menu-item index="teamExperts">专家团队</el-menu-item>
                <!-- <el-menu-item index="regist">登录/注册新用户</el-menu-item> -->
              </el-submenu>
              <el-submenu index="3">
                <template slot="title">学术会议</template>
                <el-menu-item index="conNotice">会议通知</el-menu-item>
                <el-menu-item index="newsSta">新闻动态</el-menu-item>
              </el-submenu>
              <el-submenu index="4">
                <template slot="title">继续教育</template>
                <el-menu-item index="teachVideo">教学视频</el-menu-item>
                <!-- <el-menu-item index="picStudy">视频教学</el-menu-item> -->
                <template v-if="acalitOptions && acalitOptions.length">
                  <el-submenu index="4-1">
                    <template slot="title">学术文献</template>
                    <el-menu-item :index="'scholary_' + item.id" v-for="(item, index) in acalitOptions" :key="index">{{item.cyName}}</el-menu-item>
                  </el-submenu>
                </template>
                <template v-else>
                  <el-menu-item index="scholary">学术文献</el-menu-item>
                </template>
                <!-- acalitOptions -->
                <el-menu-item index="caseCenter">病例中心</el-menu-item>
                <!-- <el-menu-item index="CellSection">细胞阅片</el-menu-item> -->
                <el-menu-item index="testCenter">考试中心</el-menu-item>
              </el-submenu>
              <el-menu-item index="aboutWe">联系我们</el-menu-item>
            </el-menu>
          </div>
          <!--menu-->
          <!-- <div class="mainMenu">
            <div
              class="mainMenu_unit"
              style="cursor: pointer"
              @click="toItemPage('/')"
              @mouseover="openSubmenu(0)"
            >
              网站首页
            </div>
            <div class="mainMenu_unit" @mouseover="openSubmenu(1)">
              关于分会
            </div>
            <div class="mainMenu_unit" @mouseover="openSubmenu(2)">
              学术会议
            </div>
            <div class="mainMenu_unit" @mouseover="openSubmenu(3)">
              继续教育
            </div>
            <div
              class="mainMenu_unit"
              style="cursor: pointer"
              @click="toItemPage('aboutWe')"
              @mouseover="openSubmenu(0)"
            >
              联系我们
            </div>

            <div class="subMenu_all subMenu_1" style="display: none">
              <div class="subMenu_unit" @click="toItemPage('synopsis')">
                分会简介
              </div>
              <div class="subMenu_unit" @click="toItemPage('orgChart')">
                组织架构
              </div>
              <div class="subMenu_unit" @click="toItemPage('teamExperts')">
                专家团队
              </div>
            </div>
            <div class="subMenu_all subMenu_2" style="display: none">
              <div class="subMenu_unit" @click="toItemPage('conNotice')">
                会议通知
              </div>
              <div class="subMenu_unit" @click="toItemPage('newsSta')">
                新闻动态
              </div>
            </div>
            <div class="subMenu_all subMenu_3" style="display: none">
              <div class="subMenu_unit" @click="toItemPage('teachVideo')">
                教学视频
              </div>
              <div class="subMenu_unit" @click="toItemPage('picStudy')">
                视频教学
              </div>
              <div class="subMenu_unit" @click="toItemPage('scholary')">
                学术文献
              </div>
              <div class="subMenu_unit" @click="toItemPage('caseCenter')">
                病例中心
              </div>
              <div class="subMenu_unit" @click="toItemPage('testCenter')">
                考试中心
              </div>
              <div class="subMenu_unit" @click="toItemPage('CellSection')">
                细胞阅片
              </div>
            </div>
          </div> -->
          <!--userLogin-->
          <div class="userLogin">
            <template v-if="userName == '登录/注册新用户'">
              <a href="#" class="link_white" @click="toItemPage('regist')">{{
                userName
              }}</a>
            </template>
            <template v-else>
              <el-dropdown @command="dropdownCommand">
                <span class="link_white">
                  {{userName}}
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="user">个人中心</el-dropdown-item>
                  <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </div>
        </div>
      </div>
    </header>
    <body>
      <div>
        <el-dialog
          title="登录"
          :visible.sync="diaLoginVisible"
          width="30%"
          :before-close="loginClose"
        >
          <div>
            <el-form :model="loginInfo">
              <el-form-item label="用户名:">
                <el-input
                  v-model="loginInfo.username"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item label="密码:" prop="pass">
                <el-input
                  type="password"
                  v-model="loginInfo.password"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>

          <div slot="footer" class="dialog-footer">
            <el-button @click="registUser">注册新用户</el-button>
            <el-button type="success" @click="goLoign">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <div>
        <el-dialog
          title="注册新用户"
          :visible.sync="dialogRegistVisible"
          width="45%"
        >
          <el-form :model="register" label-width="96px">
            <el-row>
              <el-col :span="12">
                <el-form-item label="用户名:">
                  <el-input
                    v-model="register.loginname"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="职称:">
                  <el-input
                    v-model="register.jobtitle"
                    autocomplete="off"
                  ></el-input> </el-form-item
                >
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="密码:">
                  <el-input
                    v-model="register.password"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="职务:">
                  <el-input
                    v-model="register.duties"
                    autocomplete="off"
                  ></el-input> </el-form-item
                >
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="姓名:">
                  <el-input
                    v-model="register.username"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电话:">
                  <el-input
                    v-model="register.phone"
                    autocomplete="off"
                  ></el-input> </el-form-item
                >
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="公司:">
                  <el-input
                    v-model="register.company"
                    autocomplete="off"
                  ></el-input> </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="微信:">
                  <el-input
                    v-model="register.weixin"
                    autocomplete="off"
                  ></el-input> </el-form-item
                >
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="科室:">
                  <el-input
                    v-model="register.deptks"
                    autocomplete="off"
                  ></el-input> </el-form-item
                >
              </el-col>
              <el-col :span="12">
                <el-form-item label="邮箱:">
                  <el-input
                    v-model="register.email"
                    autocomplete="off"
                  ></el-input> </el-form-item
                >
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="专业:">
                  <el-input
                    v-model="register.speci"
                    autocomplete="off"
                  ></el-input> </el-form-item
                >
              </el-col>
              <el-col :span="12">
                <el-form-item label="资格证编码:">
                  <el-input v-model="register.ceofel" autocomplete="off"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="">
              <!-- <el-input v-model="register.ceofel" autocomplete="off"></el-input> -->
              <el-checkbox v-model="checked"></el-checkbox>
              <span>我已阅读并同意<span style="color:#409EFF;cursor: pointer;" @click="dialogFwxyVisible = true">《服务协议》</span></span>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="loginUser">去登录</el-button>
            <el-button type="success" @click="addRegister">注 册</el-button>
          </div>
        </el-dialog>
        <el-dialog
          title="服务协议"
          :visible.sync="dialogFwxyVisible"
          append-to-body
          fullscreen
          width="45%"
        >
          <h1 class="h-center">中华人民共和国个人信息保护法</h1>
          <p class="h-center">（2021年8月20日第十三届全国人民代表大会常务委员会第三十次会议通过）</p>
          <h3>目   录</h3>
          <h3>第一章  总  则</h3>
          <h3>第二章  个人信息处理规则</h3>
          <h3 style="text-indent:32px">   第一节 一般规定</h3>
          <h3 style="text-indent:32px">   第二节 敏感个人信息的处理规则</h3>
          <h3 style="text-indent:32px">   第三节 国家机关处理个人信息的特别规定</h3>
          <h3>第三章  个人信息跨境提供的规则</h3>
          <h3>第四章  个人在个人信息处理活动中的权利</h3>
          <h3>第五章  个人信息处理者的义务</h3>
          <h3>第六章  履行个人信息保护职责的部门</h3>
          <h3>第七章  法律责任</h3>
          <h3>第八章  附  则</h3>
          
          <h3 class="h-center">第一章　总　　则</h3>
          <p class="t-indent">第一条　为了保护个人信息权益，规范个人信息处理活动，促进个人信息合理利用，根据宪法，制定本法。</p>
          <p class="t-indent">第二条　自然人的个人信息受法律保护，任何组织、个人不得侵害自然人的个人信息权益。</p>
          <p class="t-indent">第三条　在中华人民共和国境内处理自然人个人信息的活动，适用本法。</p>
          <p class="t-indent">在中华人民共和国境外处理中华人民共和国境内自然人个人信息的活动，有下列情形之一的，也适用本法：</p>
          <p class="t-indent">（一）以向境内自然人提供产品或者服务为目的；</p>
          <p class="t-indent">（二）分析、评估境内自然人的行为；</p>
          <p class="t-indent">（三）法律、行政法规规定的其他情形。</p>
          <p class="t-indent">第四条　个人信息是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。</p>
          <p class="t-indent">个人信息的处理包括个人信息的收集、存储、使用、加工、传输、提供、公开、删除等。</p>
          <p class="t-indent">第五条　处理个人信息应当遵循合法、正当、必要和诚信原则，不得通过误导、欺诈、胁迫等方式处理个人信息。</p>
          <p class="t-indent">第六条　处理个人信息应当具有明确、合理的目的，并应当与处理目的直接相关，采取对个人权益影响最小的方式。</p>
          <p class="t-indent">收集个人信息，应当限于实现处理目的的最小范围，不得过度收集个人信息。</p>
          <p class="t-indent">第七条　处理个人信息应当遵循公开、透明原则，公开个人信息处理规则，明示处理的目的、方式和范围。</p>
          <p class="t-indent">第八条　处理个人信息应当保证个人信息的质量，避免因个人信息不准确、不完整对个人权益造成不利影响。</p>
          <p class="t-indent">第九条　个人信息处理者应当对其个人信息处理活动负责，并采取必要措施保障所处理的个人信息的安全。</p>
          <p class="t-indent">第十条　任何组织、个人不得非法收集、使用、加工、传输他人个人信息，不得非法买卖、提供或者公开他人个人信息；不得从事危害国家安全、公共利益的个人信息处理活动。</p>
          <p class="t-indent">第十一条　国家建立健全个人信息保护制度，预防和惩治侵害个人信息权益的行为，加强个人信息保护宣传教育，推动形成政府、企业、相关社会组织、公众共同参与个人信息保护的良好环境。</p>
          <p class="t-indent">第十二条　国家积极参与个人信息保护国际规则的制定，促进个人信息保护方面的国际交流与合作，推动与其他国家、地区、国际组织之间的个人信息保护规则、标准等互认。</p>
          
          <h3 class="h-center">第二章　个人信息处理规则</h3>
          <p class="h-center">第一节　一般规定</p>

          <p class="t-indent">第十三条　符合下列情形之一的，个人信息处理者方可处理个人信息：</p>
          <p class="t-indent">（一）取得个人的同意；</p>
          <p class="t-indent">（二）为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；</p>
          <p class="t-indent">（三）为履行法定职责或者法定义务所必需；</p>
          <p class="t-indent">（四）为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；</p>
          <p class="t-indent">（五）为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；</p>
          <p class="t-indent">（六）依照本法规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；</p>
          <p class="t-indent">（七）法律、行政法规规定的其他情形。</p>
          <p class="t-indent">依照本法其他有关规定，处理个人信息应当取得个人同意，但是有前款第二项至第七项规定情形的，不需取得个人同意。</p>
          <p class="t-indent">第十四条　基于个人同意处理个人信息的，该同意应当由个人在充分知情的前提下自愿、明确作出。法律、行政法规规定处理个人信息应当取得个人单独同意或者书面同意的，从其规定。</p>
          <p class="t-indent">个人信息的处理目的、处理方式和处理的个人信息种类发生变更的，应当重新取得个人同意。</p>
          <p class="t-indent">第十五条　基于个人同意处理个人信息的，个人有权撤回其同意。个人信息处理者应当提供便捷的撤回同意的方式。</p>
          <p class="t-indent">个人撤回同意，不影响撤回前基于个人同意已进行的个人信息处理活动的效力。</p>
          <p class="t-indent">第十六条　个人信息处理者不得以个人不同意处理其个人信息或者撤回同意为由，拒绝提供产品或者服务；处理个人信息属于提供产品或者服务所必需的除外。</p>
          <p class="t-indent">第十七条　个人信息处理者在处理个人信息前，应当以显著方式、清晰易懂的语言真实、准确、完整地向个人告知下列事项：</p>
          <p class="t-indent">（一）个人信息处理者的名称或者姓名和联系方式；</p>
          <p class="t-indent">（二）个人信息的处理目的、处理方式，处理的个人信息种类、保存期限；</p>
          <p class="t-indent">（三）个人行使本法规定权利的方式和程序；</p>
          <p class="t-indent">（四）法律、行政法规规定应当告知的其他事项。</p>
          <p class="t-indent">前款规定事项发生变更的，应当将变更部分告知个人。</p>
          <p class="t-indent">个人信息处理者通过制定个人信息处理规则的方式告知第一款规定事项的，处理规则应当公开，并且便于查阅和保存。</p>
          <p class="t-indent">第十八条　个人信息处理者处理个人信息，有法律、行政法规规定应当保密或者不需要告知的情形的，可以不向个人告知前条第一款规定的事项。</p>
          <p class="t-indent">紧急情况下为保护自然人的生命健康和财产安全无法及时向个人告知的，个人信息处理者应当在紧急情况消除后及时告知。</p>
          <p class="t-indent">第十九条　除法律、行政法规另有规定外，个人信息的保存期限应当为实现处理目的所必要的最短时间。</p>
          <p class="t-indent">第二十条　两个以上的个人信息处理者共同决定个人信息的处理目的和处理方式的，应当约定各自的权利和义务。但是，该约定不影响个人向其中任何一个个人信息处理者要求行使本法规定的权利。</p>
          <p class="t-indent">个人信息处理者共同处理个人信息，侵害个人信息权益造成损害的，应当依法承担连带责任。
</p>
          <p class="t-indent">第二十一条　个人信息处理者委托处理个人信息的，应当与受托人约定委托处理的目的、期限、处理方式、个人信息的种类、保护措施以及双方的权利和义务等，并对受托人的个人信息处理活动进行监督。</p>
          <p class="t-indent">受托人应当按照约定处理个人信息，不得超出约定的处理目的、处理方式等处理个人信息；委托合同不生效、无效、被撤销或者终止的，受托人应当将个人信息返还个人信息处理者或者予以删除，不得保留。</p>
          <p class="t-indent">未经个人信息处理者同意，受托人不得转委托他人处理个人信息。</p>
          <p class="t-indent">第二十二条　个人信息处理者因合并、分立、解散、被宣告破产等原因需要转移个人信息的，应当向个人告知接收方的名称或者姓名和联系方式。接收方应当继续履行个人信息处理者的义务。接收方变更原先的处理目的、处理方式的，应当依照本法规定重新取得个人同意。

</p>
          <p class="t-indent">第二十三条　个人信息处理者向其他个人信息处理者提供其处理的个人信息的，应当向个人告知接收方的名称或者姓名、联系方式、处理目的、处理方式和个人信息的种类，并取得个人的单独同意。接收方应当在上述处理目的、处理方式和个人信息的种类等范围内处理个人信息。接收方变更原先的处理目的、处理方式的，应当依照本法规定重新取得个人同意。</p>
          <p class="t-indent">第二十四条　个人信息处理者利用个人信息进行自动化决策，应当保证决策的透明度和结果公平、公正，不得对个人在交易价格等交易条件上实行不合理的差别待遇。</p>
          <p class="t-indent">通过自动化决策方式向个人进行信息推送、商业营销，应当同时提供不针对其个人特征的选项，或者向个人提供便捷的拒绝方式。</p>
          <p class="t-indent">通过自动化决策方式作出对个人权益有重大影响的决定，个人有权要求个人信息处理者予以说明，并有权拒绝个人信息处理者仅通过自动化决策的方式作出决定。</p>
          <p class="t-indent">第二十五条　个人信息处理者不得公开其处理的个人信息，取得个人单独同意的除外。</p>
          <p class="t-indent">第二十六条　在公共场所安装图像采集、个人身份识别设备，应当为维护公共安全所必需，遵守国家有关规定，并设置显著的提示标识。所收集的个人图像、身份识别信息只能用于维护公共安全的目的，不得用于其他目的；取得个人单独同意的除外。</p>
          <p class="t-indent">第二十七条　个人信息处理者可以在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；个人明确拒绝的除外。个人信息处理者处理已公开的个人信息，对个人权益有重大影响的，应当依照本法规定取得个人同意。</p>
          <p class="h-center">第二节  敏感个人信息的处理规则</p>
          <p class="t-indent">第二十八条　敏感个人信息是一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。</p>
          <p class="t-indent">只有在具有特定的目的和充分的必要性，并采取严格保护措施的情形下，个人信息处理者方可处理敏感个人信息。</p>
          <p class="t-indent">第二十九条　处理敏感个人信息应当取得个人的单独同意；法律、行政法规规定处理敏感个人信息应当取得书面同意的，从其规定。</p>
          <p class="t-indent">第三十条　个人信息处理者处理敏感个人信息的，除本法第十七条第一款规定的事项外，还应当向个人告知处理敏感个人信息的必要性以及对个人权益的影响；依照本法规定可以不向个人告知的除外。</p>
          <p class="t-indent">第三十一条　个人信息处理者处理不满十四周岁未成年人个人信息的，应当取得未成年人的父母或者其他监护人的同意。</p>
          <p class="t-indent">个人信息处理者处理不满十四周岁未成年人个人信息的，应当制定专门的个人信息处理规则。</p>
          <p class="t-indent">第三十二条　法律、行政法规对处理敏感个人信息规定应当取得相关行政许可或者作出其他限制的，从其规定。</p>
          <p class="h-center">第三节　国家机关处理个人信息的特别规定</p>
          <p class="t-indent">第三十三条　国家机关处理个人信息的活动，适用本法；本节有特别规定的，适用本节规定。</p>
          <p class="t-indent">第三十四条　国家机关为履行法定职责处理个人信息，应当依照法律、行政法规规定的权限、程序进行，不得超出履行法定职责所必需的范围和限度。</p>
          <p class="t-indent">第三十五条　国家机关为履行法定职责处理个人信息，应当依照本法规定履行告知义务；有本法第十八条第一款规定的情形，或者告知将妨碍国家机关履行法定职责的除外。</p>
          <p class="t-indent">第三十六条　国家机关处理的个人信息应当在中华人民共和国境内存储；确需向境外提供的，应当进行安全评估。安全评估可以要求有关部门提供支持与协助。

</p>
          <p class="t-indent">第三十七条　法律、法规授权的具有管理公共事务职能的组织为履行法定职责处理个人信息，适用本法关于国家机关处理个人信息的规定。</p>
          <h3 class="h-center">第三章　个人信息跨境提供的规则</h3>
          <p class="t-indent">第三十八条　个人信息处理者因业务等需要，确需向中华人民共和国境外提供个人信息的，应当具备下列条件之一：</p>
          <p class="t-indent">（一）依照本法第四十条的规定通过国家网信部门组织的安全评估；</p>
          <p class="t-indent">（二）按照国家网信部门的规定经专业机构进行个人信息保护认证；</p>
          <p class="t-indent">（三）按照国家网信部门制定的标准合同与境外接收方订立合同，约定双方的权利和义务；</p>
          <p class="t-indent">（四）法律、行政法规或者国家网信部门规定的其他条件。</p>
          <p class="t-indent">中华人民共和国缔结或者参加的国际条约、协定对向中华人民共和国境外提供个人信息的条件等有规定的，可以按照其规定执行。</p>
          <p class="t-indent">个人信息处理者应当采取必要措施，保障境外接收方处理个人信息的活动达到本法规定的个人信息保护标准。</p>
          <p class="t-indent">第三十九条　个人信息处理者向中华人民共和国境外提供个人信息的，应当向个人告知境外接收方的名称或者姓名、联系方式、处理目的、处理方式、个人信息的种类以及个人向境外接收方行使本法规定权利的方式和程序等事项，并取得个人的单独同意。</p>
          <p class="t-indent">第四十条　关键信息基础设施运营者和处理个人信息达到国家网信部门规定数量的个人信息处理者，应当将在中华人民共和国境内收集和产生的个人信息存储在境内。确需向境外提供的，应当通过国家网信部门组织的安全评估；法律、行政法规和国家网信部门规定可以不进行安全评估的，从其规定。</p>
          <p class="t-indent">第四十一条　中华人民共和国主管机关根据有关法律和中华人民共和国缔结或者参加的国际条约、协定，或者按照平等互惠原则，处理外国司法或者执法机构关于提供存储于境内个人信息的请求。非经中华人民共和国主管机关批准，个人信息处理者不得向外国司法或者执法机构提供存储于中华人民共和国境内的个人信息。</p>
          <p class="t-indent">第四十二条　境外的组织、个人从事侵害中华人民共和国公民的个人信息权益，或者危害中华人民共和国国家安全、公共利益的个人信息处理活动的，国家网信部门可以将其列入限制或者禁止个人信息提供清单，予以公告，并采取限制或者禁止向其提供个人信息等措施。</p>
          <p class="t-indent">第四十三条　任何国家或者地区在个人信息保护方面对中华人民共和国采取歧视性的禁止、限制或者其他类似措施的，中华人民共和国可以根据实际情况对该国家或者地区对等采取措施。</p>
          <h3 class="h-center">第四章　个人在个人信息处理活动中的权利</h3>
          <p class="t-indent">第四十四条　个人对其个人信息的处理享有知情权、决定权，有权限制或者拒绝他人对其个人信息进行处理；法律、行政法规另有规定的除外。</p>
          <p class="t-indent">第四十五条　个人有权向个人信息处理者查阅、复制其个人信息；有本法第十八条第一款、第三十五条规定情形的除外。</p>
          <p class="t-indent">个人请求查阅、复制其个人信息的，个人信息处理者应当及时提供。</p>
          <p class="t-indent">个人请求将个人信息转移至其指定的个人信息处理者，符合国家网信部门规定条件的，个人信息处理者应当提供转移的途径。</p>
          <p class="t-indent">第四十六条　个人发现其个人信息不准确或者不完整的，有权请求个人信息处理者更正、补充。</p>
          <p class="t-indent">个人请求更正、补充其个人信息的，个人信息处理者应当对其个人信息予以核实，并及时更正、补充。</p>
          <p class="t-indent">第四十七条　有下列情形之一的，个人信息处理者应当主动删除个人信息；个人信息处理者未删除的，个人有权请求删除：</p>
          <p class="t-indent">（一）处理目的已实现、无法实现或者为实现处理目的不再必要；</p>
          <p class="t-indent">（二）个人信息处理者停止提供产品或者服务，或者保存期限已届满；</p>
          <p class="t-indent">（三）个人撤回同意；</p>
          <p class="t-indent">（四）个人信息处理者违反法律、行政法规或者违反约定处理个人信息；</p>
          <p class="t-indent">（五）法律、行政法规规定的其他情形。</p>
          <p class="t-indent">法律、行政法规规定的保存期限未届满，或者删除个人信息从技术上难以实现的，个人信息处理者应当停止除存储和采取必要的安全保护措施之外的处理。</p>
          <p class="t-indent">第四十八条　个人有权要求个人信息处理者对其个人信息处理规则进行解释说明。</p>
          <p class="t-indent">第四十九条　自然人死亡的，其近亲属为了自身的合法、正当利益，可以对死者的相关个人信息行使本章规定的查阅、复制、更正、删除等权利；死者生前另有安排的除外。</p>
          <p class="t-indent">第五十条　个人信息处理者应当建立便捷的个人行使权利的申请受理和处理机制。拒绝个人行使权利的请求的，应当说明理由。</p>
          <p class="t-indent">个人信息处理者拒绝个人行使权利的请求的，个人可以依法向人民法院提起诉讼。</p>
          <h3 class="h-center">第五章　个人信息处理者的义务</h3>
          <p class="t-indent">第五十一条　个人信息处理者应当根据个人信息的处理目的、处理方式、个人信息的种类以及对个人权益的影响、可能存在的安全风险等，采取下列措施确保个人信息处理活动符合法律、行政法规的规定，并防止未经授权的访问以及个人信息泄露、篡改、丢失：</p>
          <p class="t-indent">（一）制定内部管理制度和操作规程；</p>
          <p class="t-indent">（二）对个人信息实行分类管理；</p>
          <p class="t-indent">（三）采取相应的加密、去标识化等安全技术措施；</p>
          <p class="t-indent">（四）合理确定个人信息处理的操作权限，并定期对从业人员进行安全教育和培训；</p>
          <p class="t-indent">（五）制定并组织实施个人信息安全事件应急预案；</p>
          <p class="t-indent">（六）法律、行政法规规定的其他措施。</p>
          <p class="t-indent">第五十二条　处理个人信息达到国家网信部门规定数量的个人信息处理者应当指定个人信息保护负责人，负责对个人信息处理活动以及采取的保护措施等进行监督。</p>
          <p class="t-indent">个人信息处理者应当公开个人信息保护负责人的联系方式，并将个人信息保护负责人的姓名、联系方式等报送履行个人信息保护职责的部门。</p>
          <p class="t-indent">第五十三条　本法第三条第二款规定的中华人民共和国境外的个人信息处理者，应当在中华人民共和国境内设立专门机构或者指定代表，负责处理个人信息保护相关事务，并将有关机构的名称或者代表的姓名、联系方式等报送履行个人信息保护职责的部门。</p>
          <p class="t-indent">第五十四条　个人信息处理者应当定期对其处理个人信息遵守法律、行政法规的情况进行合规审计。</p>
          <p class="t-indent">第五十五条　有下列情形之一的，个人信息处理者应当事前进行个人信息保护影响评估，并对处理情况进行记录：</p>
          <p class="t-indent">（一）处理敏感个人信息；</p>
          <p class="t-indent">（二）利用个人信息进行自动化决策；</p>
          <p class="t-indent">（三）委托处理个人信息、向其他个人信息处理者提供个人信息、公开个人信息；</p>
          <p class="t-indent">（四）向境外提供个人信息；</p>
          <p class="t-indent">（五）其他对个人权益有重大影响的个人信息处理活动。</p>
          <p class="t-indent">第五十六条　个人信息保护影响评估应当包括下列内容：</p>
          <p class="t-indent">（一）个人信息的处理目的、处理方式等是否合法、正当、必要；</p>
          <p class="t-indent">（二）对个人权益的影响及安全风险；</p>
          <p class="t-indent">（三）所采取的保护措施是否合法、有效并与风险程度相适应。</p>
          <p class="t-indent">个人信息保护影响评估报告和处理情况记录应当至少保存三年。</p>
          <p class="t-indent">第五十七条　发生或者可能发生个人信息泄露、篡改、丢失的，个人信息处理者应当立即采取补救措施，并通知履行个人信息保护职责的部门和个人。通知应当包括下列事项：</p>
          <p class="t-indent">（一）发生或者可能发生个人信息泄露、篡改、丢失的信息种类、原因和可能造成的危害；</p>
          <p class="t-indent">（二）个人信息处理者采取的补救措施和个人可以采取的减轻危害的措施；</p>
          <p class="t-indent">（三）个人信息处理者的联系方式。</p>
          <p class="t-indent">个人信息处理者采取措施能够有效避免信息泄露、篡改、丢失造成危害的，个人信息处理者可以不通知个人；履行个人信息保护职责的部门认为可能造成危害的，有权要求个人信息处理者通知个人。</p>
          <p class="t-indent">第五十八条　提供重要互联网平台服务、用户数量巨大、业务类型复杂的个人信息处理者，应当履行下列义务：</p>
          <p class="t-indent">（一）按照国家规定建立健全个人信息保护合规制度体系，成立主要由外部成员组成的独立机构对个人信息保护情况进行监督；</p>
          <p class="t-indent">（二）遵循公开、公平、公正的原则，制定平台规则，明确平台内产品或者服务提供者处理个人信息的规范和保护个人信息的义务；</p>
          <p class="t-indent">（三）对严重违反法律、行政法规处理个人信息的平台内的产品或者服务提供者，停止提供服务；</p>
          <p class="t-indent">（四）定期发布个人信息保护社会责任报告，接受社会监督。</p>
          <p class="t-indent">第五十九条　接受委托处理个人信息的受托人，应当依照本法和有关法律、行政法规的规定，采取必要措施保障所处理的个人信息的安全，并协助个人信息处理者履行本法规定的义务。</p>
          <h3 class="h-center">第六章　履行个人信息保护职责的部门</h3>
          <p class="t-indent">第六十条　国家网信部门负责统筹协调个人信息保护工作和相关监督管理工作。国务院有关部门依照本法和有关法律、行政法规的规定，在各自职责范围内负责个人信息保护和监督管理工作。</p>
          <p class="t-indent">县级以上地方人民政府有关部门的个人信息保护和监督管理职责，按照国家有关规定确定。</p>
          <p class="t-indent">前两款规定的部门统称为履行个人信息保护职责的部门。</p>
          <p class="t-indent">第六十一条　履行个人信息保护职责的部门履行下列个人信息保护职责：</p>
          <p class="t-indent">（一）开展个人信息保护宣传教育，指导、监督个人信息处理者开展个人信息保护工作；</p>
          <p class="t-indent">（二）接受、处理与个人信息保护有关的投诉、举报；</p>
          <p class="t-indent">（三）组织对应用程序等个人信息保护情况进行测评，并公布测评结果；</p>
          <p class="t-indent">（四）调查、处理违法个人信息处理活动；</p>
          <p class="t-indent">（五）法律、行政法规规定的其他职责。</p>
          <p class="t-indent">第六十二条　国家网信部门统筹协调有关部门依据本法推进下列个人信息保护工作：</p>
          <p class="t-indent">（一）制定个人信息保护具体规则、标准；</p>
          <p class="t-indent">（二）针对小型个人信息处理者、处理敏感个人信息以及人脸识别、人工智能等新技术、新应用，制定专门的个人信息保护规则、标准；</p>
          <p class="t-indent">（三）支持研究开发和推广应用安全、方便的电子身份认证技术，推进网络身份认证公共服务建设；</p>
          <p class="t-indent">（四）推进个人信息保护社会化服务体系建设，支持有关机构开展个人信息保护评估、认证服务；</p>
          <p class="t-indent">（五）完善个人信息保护投诉、举报工作机制。

</p>
          <p class="t-indent">第六十三条　履行个人信息保护职责的部门履行个人信息保护职责，可以采取下列措施：</p>
          <p class="t-indent">（一）询问有关当事人，调查与个人信息处理活动有关的情况;</p>
          <p class="t-indent">（二）查阅、复制当事人与个人信息处理活动有关的合同、记录、账簿以及其他有关资料;</p>
          <p class="t-indent">（三）实施现场检查，对涉嫌违法的个人信息处理活动进行调查;</p>
          <p class="t-indent">（四）检查与个人信息处理活动有关的设备、物品;对有证据证明是用于违法个人信息处理活动的设备、物品，向本部门主要负责人书面报告并经批准，可以查封或者扣押。</p>
          <p class="t-indent">履行个人信息保护职责的部门依法履行职责，当事人应当予以协助、配合，不得拒绝、阻挠。</p>
          <p class="t-indent">第六十四条　履行个人信息保护职责的部门在履行职责中，发现个人信息处理活动存在较大风险或者发生个人信息安全事件的，可以按照规定的权限和程序对该个人信息处理者的法定代表人或者主要负责人进行约谈，或者要求个人信息处理者委托专业机构对其个人信息处理活动进行合规审计。个人信息处理者应当按照要求采取措施，进行整改，消除隐患。</p>
          <p class="t-indent">履行个人信息保护职责的部门在履行职责中，发现违法处理个人信息涉嫌犯罪的，应当及时移送公安机关依法处理。</p>
          <p class="t-indent">第六十五条　任何组织、个人有权对违法个人信息处理活动向履行个人信息保护职责的部门进行投诉、举报。收到投诉、举报的部门应当依法及时处理，并将处理结果告知投诉、举报人。</p>
          <p class="t-indent">履行个人信息保护职责的部门应当公布接受投诉、举报的联系方式。

</p>
          <h3 class="h-center">第七章　法律责任</h3>
          <p class="t-indent">第六十六条　违反本法规定处理个人信息，或者处理个人信息未履行本法规定的个人信息保护义务的，由履行个人信息保护职责的部门责令改正，给予警告，没收违法所得，对违法处理个人信息的应用程序，责令暂停或者终止提供服务；拒不改正的，并处一百万元以下罚款；对直接负责的主管人员和其他直接责任人员处一万元以上十万元以下罚款。</p>
          <p class="t-indent">有前款规定的违法行为，情节严重的，由省级以上履行个人信息保护职责的部门责令改正，没收违法所得，并处五千万元以下或者上一年度营业额百分之五以下罚款，并可以责令暂停相关业务或者停业整顿、通报有关主管部门吊销相关业务许可或者吊销营业执照；对直接负责的主管人员和其他直接责任人员处十万元以上一百万元以下罚款，并可以决定禁止其在一定期限内担任相关企业的董事、监事、高级管理人员和个人信息保护负责人。</p>
          <p class="t-indent">第六十七条　有本法规定的违法行为的，依照有关法律、行政法规的规定记入信用档案，并予以公示。

</p>
          <p class="t-indent">第六十八条　国家机关不履行本法规定的个人信息保护义务的，由其上级机关或者履行个人信息保护职责的部门责令改正；对直接负责的主管人员和其他直接责任人员依法给予处分。</p>
          <p class="t-indent">履行个人信息保护职责的部门的工作人员玩忽职守、滥用职权、徇私舞弊，尚不构成犯罪的，依法给予处分。

</p>
          <p class="t-indent">第六十九条　处理个人信息侵害个人信息权益造成损害，个人信息处理者不能证明自己没有过错的，应当承担损害赔偿等侵权责任。</p>
          <p class="t-indent">前款规定的损害赔偿责任按照个人因此受到的损失或者个人信息处理者因此获得的利益确定;个人因此受到的损失和个人信息处理者因此获得的利益难以确定的，根据实际情况确定赔偿数额。</p>
          <p class="t-indent">第七十条　个人信息处理者违反本法规定处理个人信息，侵害众多个人的权益的，人民检察院、法律规定的消费者组织和由国家网信部门确定的组织可以依法向人民法院提起诉讼。</p>
          <p class="t-indent">第七十一条　违反本法规定，构成违反治安管理行为的，依法给予治安管理处罚；构成犯罪的，依法追究刑事责任。

</p>
          <h3 class="h-center">第八章　附　　则</h3>
          <p class="t-indent">第七十二条　自然人因个人或者家庭事务处理个人信息的，不适用本法。</p>
          <p class="t-indent">法律对各级人民政府及其有关部门组织实施的统计、档案管理活动中的个人信息处理有规定的，适用其规定。</p>
          <p class="t-indent">第七十三条　本法下列用语的含义：</p>
          <p class="t-indent">（一）个人信息处理者，是指在个人信息处理活动中自主决定处理目的、处理方式的组织、个人。</p>
          <p class="t-indent">（二）自动化决策，是指通过计算机程序自动分析、评估个人的行为习惯、兴趣爱好或者经济、健康、信用状况等，并进行决策的活动。</p>
          <p class="t-indent">（三）去标识化，是指个人信息经过处理，使其在不借助额外信息的情况下无法识别特定自然人的过程。</p>
          <p class="t-indent">（四）匿名化，是指个人信息经过处理无法识别特定自然人且不能复原的过程。</p>
          <p class="t-indent">第七十四条　本法自2021年11月1日起施行。</p>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFwxyVisible = false" type="success">确定</el-button>
          </div>
        </el-dialog>
      </div>
      <div>
        <el-dialog
          title="温馨提示"
          :visible.sync="dialogIsLoginVisible"
          width="30%"
        >
          <p style="text-align: center">{{ userHint }}</p>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogIsLoginVisible = false">取 消</el-button>
            <el-button type="primary" @click="loginOut()">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </body>
    <router-view />
    <footer>
      <div class="footer_bg">
        <div>
          <p class="hint_one">联系我们</p>
          <!-- <p>北京市XXX区XXXX大街XXX号 XXXX楼888</p>
          <p>电话：010-88888888</p>
          <p>传真：010-88888888</p>
          <p>邮件：xxxxxxxxxx@163.com</p>
          <p>网址：www.xxxxx.com</p> -->
          <div class="ql-editor" v-html="myInfo"></div>
        </div>
        <el-image :src="qrCode"></el-image>
      </div>
      <p class="fotter_bg_two">
        版权所有 © 中国医药教育协会细胞病理学专业委员会
      </p>
    </footer>
  </div>
</template>

<script>
import { register, loginUser, getFirstcfg, acalitSelect } from "@/network/api";
import "../src/js/jquery-1.8.0.min.js";
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      url: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      leftLogo: require("@/assets/images/webLogo.png"),
      inputSearch: "",
      activeIndex: "/",
      index: -1,
      qrCode: require("@/assets/images/temp_3.png"),
      diaLoginVisible: false,
      loginInfo: {
        username: "",
        password: "",
      },
      myInfo: {},
      register: {},
      dialogRegistVisible: false,
      userName: "登录/注册新用户",
      isOnClickLogin: false,
      dialogIsLoginVisible: false,
      userHint: "",
      searchValue: "",
      checked: false,
      dialogFwxyVisible: false,
      acalitOptions: []
    };
  },
  computed: {
    ...mapGetters(['loginVisible']),
    loginVisible2() {
      return this.loginVisible
    }
  },
  watch: {
    loginVisible2(val) {
      if (val) {
        this.diaLoginVisible = true;
      }
    }
  },
  methods: {
    dropdownCommand(command) {
      console.log(command)
      if (command == 'logout') {
        this.userHint = "尊敬的用户" + this.userName + "您是否要退出登录 ？";
        this.dialogIsLoginVisible = true;
      } else if (command == 'user') {
        this.toItemPage('PersonalCenter')
      }
    },
    handleSelect(key, keyPath) {
      if (key.indexOf('scholary_') != -1) {
        let arr = key.split('_');
        this.toItemPage(arr[0], arr[1]);
        return;
      }
      this.toItemPage(keyPath[keyPath.length - 1], )
    },
    registUser() {
      this.diaLoginVisible = false;
      this.dialogRegistVisible = true;
    },
    loginUser() {
      this.dialogRegistVisible = false;
      this.diaLoginVisible = true;
    },
    addRegister() {
      if (!this.checked) {
        this.$message.warning('请阅读并勾选协议')
        return 
      }
      register(this.register).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "注册成功",
            type: "success",
          });
          this.loginUser();
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    /**
     * 登录
     */
    goLoign() {
      let formData = new FormData();
      formData.append("username", this.loginInfo.username);
      formData.append("password", this.loginInfo.password);
      loginUser(formData).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "登录成功",
            type: "success",
          });
          localStorage.setItem("userToken", res.token);
          localStorage.setItem("userName", this.loginInfo.username);
          this.userName = this.loginInfo.username;
          this.diaLoginVisible = false;
          this.isOnClickLogin = true;
          this.loginInfo = {};
          location.reload()
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    openSubmenu(num) {
      var subMenuClass = ".subMenu_" + num;
      $(".subMenu_all").fadeOut(100);
      $(subMenuClass).fadeIn(200);
    },
    openSubmenu2(num) {
      var subMenuClass = ".subMenu_" + num;
      // $(".subMenu_all").fadeOut(100);
      $(subMenuClass).fadeIn(200);
    },
    toItemPage(path, params) {
      if (path == "regist") {
        this.isLogin();
      } else if (params) {
        this.$router.push({
          path: '/' + path,
          query: {
            p: params
          }
        });
      } else {
        this.$router.push(path);
      }
    },
    isLogin() {
      let userName = localStorage.getItem("userName");
      if (userName != null) {
        // this.userHint = "尊敬的用户" + userName + "您是否要退出登录 ？";
        // this.dialogIsLoginVisible = true;
        this.$message.success('目前您已登录')
      } else {
        this.diaLoginVisible = true;
      }
    },
    loginOut() {
      localStorage.clear();
      this.userName = "登录/注册新用户";
      this.dialogIsLoginVisible = false;
      this.$message.success('退出成功')
      location.reload();
    },
    loginClose() {
      this.$store.dispatch('app/setVisible', false)
      this.diaLoginVisible = false;
      this.loginInfo = {};
    },
    showSearch: function () {
      console.log("----------- : ", this.searchValue);
      if (this.searchValue == "") {
        this.$message.error("请输入要查询的内容");
      } else {
        this.$router.push({
          path: "/searchMsg",
          query: { searchInfo: this.searchValue },
        });
        this.searchValue = "";
      }
    },
    initData() {
      acalitSelect().then(res => {
        this.acalitOptions = res.data;
      })
      let formData = new FormData();
      formData.append("dpCode", "DP04");
      getFirstcfg(formData).then((res) => {
        if (res.code == 200) {
          this.myInfo = res.data.stContent;
        }
      });
    },
  },
  mounted() {
    console.log("执行mounted()");
    this.initData();
    let userName = localStorage.getItem("userName");
    if (userName != null) {
      this.userName = userName;
      this.isOnClickLogin = true;
    }

    $(document).ready(function (e) {
      //menu style
      $(".mainMenu_unit").mouseover(function () {
        $(".mainMenu_unit").removeClass("mainMenu_unit_on");
        $(".subMenu_unit").removeClass("subMenu_unit_on");
        $(this).addClass("mainMenu_unit_on");
      });
      $(".mainMenu_unit").mouseout(function () {
        $(".mainMenu_unit").removeClass("mainMenu_unit_on");
        $(".subMenu_unit").removeClass("subMenu_unit_on");
      });
      $(".subMenu_unit").mouseover(function () {
        $(".subMenu_unit").removeClass("subMenu_unit_on");
        $(this).addClass("subMenu_unit_on");
      });
      $(".mainMenu_unit").mouseout(function () {
        $(".subMenu_unit").removeClass("subMenu_unit_on");
      });
      $(".subMenu_all").mouseleave(function () {
        $(".subMenu_all").hide(0);
      });
    });
  },
};
</script>

<style>
@import "../src/css/uiStyle.css";
body {
  margin: 0;
  padding: 0;
}
header {
  margin-bottom: 16px;
}
.headerOne {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
footer {
  background-color: #4a7845;
  color: white;
  padding-bottom: 32px;
}
.footer_bg {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding-top: 16px;
}
.fotter_bg_two {
  text-align: center;
  font-size: 14px;
  margin-top: 32px;
}
p {
  margin-top: 0;
  margin-bottom: 0;
}
.le-menu {
  width: 670px;
  float: left;
}
.el-menu {
  height: 48px !important;
  background: #4a7845 !important;
}
.el-menu.el-menu--horizontal {
  border: none !important;
}
.el-menu .el-menu-item {
  height: 48px !important;
  line-height: 48px !important;
  color: #fff !important;
  background: #4a7845 !important;
  font-size: 16px !important;
}
.el-menu--horizontal>.el-submenu .el-submenu__title {
  color: #fff !important;
  height: 48px !important;
  line-height: 48px !important;
  font-size: 16px !important;
}
.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
  color: #fff !important;
  background: #4a7845 !important;
}
.el-menu--horizontal>.el-menu-item.is-active {
  border: none !important;
  color: #fff !important;
}
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
  border: none !important;
  color: #fff !important;
}
.el-menu--horizontal .el-menu .el-menu-item.is-active, .el-menu--horizontal .el-menu .el-submenu.is-active>.el-submenu__title {
  color: #fff !important;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  background: #4a7845 !important;
  color: #fff !important;
}
.el-menu--horizontal .el-menu--popup .el-menu-item:hover {
  background: #78bf7d !important;
}
.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title {
  background: #4a7845 !important;
  color: #fff !important;
  height: 48px !important;
  line-height: 48px !important;
  font-size: 16px !important;
}
.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title:hover {
  background: #4a7845 !important;
  color: #fff !important;
}
.el-menu--horizontal>.el-submenu .el-submenu__icon-arrow {
  display: none !important;
}
.el-submenu__icon-arrow {
  display: none !important;
}
.el-menu--popup {
  min-width: 100px !important;
  height: 36px !important;
  padding: 0 !important;
}

.menu_bg {
  width: 134px;
  text-align: center;
  font-size: 18px;
  margin-top: 8px;
  margin-bottom: 8px;
}
.hint_one {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 16px;
}
/* .subMenu_1,.subMenu_2,.subMenu_3{
  display: none;
} */
.subMenu_all {
  display: none;
}
.subMenu_1_active,
.subMenu_2_active,
.subMenu_3_active {
  display: block;
}
.h-center {
  text-align: center;
}
.t-indent {
  text-indent: 32px;
}
</style>


// WEBPACK FOOTER //
// src/App.vue